export const PageHeader = ({ title, display }) =>
  display ? (
    <div className="app-page-header">
      <h3 className="mb-0 mr-3 font-weight-semibold">{title}</h3>
    </div>
  ) : null;

export default PageHeader;
